import React from "react";
import { useIcons } from "../../contexts/IconContext";

const DisplayIcon = ({ name, height = 75, width = 75 }) => {
  const { icons, isLoading } = useIcons();

  if (isLoading) {
    return <p>Loading icons...</p>;
  }

  const icon = icons.find((icon) => icon.name === name);

  if (!icon) {
    return <p>{name}</p>;
  }

  return (
    <div>
      <img src={icon.url} alt={name} style={{ width, height }} />
    </div>
  );
};

export default DisplayIcon;
